"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageType = exports.Parser = void 0;
const types_1 = require("./types");
Object.defineProperty(exports, "PageType", { enumerable: true, get: function () { return types_1.PageType; } });
const parser_1 = require("../parser");
const map_1 = require("./map");
const types_2 = require("../types");
class Parser extends parser_1.default {
    constructor() {
        super(...arguments);
        this.schemeType = types_2.SchemeType.LITB;
        this.protocolReg = /^litb:\/\/([\w\/]+)(?:\?([\w\W]+))?$/i;
        this.map = map_1.TypeMap;
        this.genWebLink = link => link;
    }
}
exports.Parser = Parser;
